import { render, staticRenderFns } from "./step_5.vue?vue&type=template&id=2dbd7a8d&scoped=true&lang=pug&"
import script from "./step_5.vue?vue&type=script&lang=js&"
export * from "./step_5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd7a8d",
  null
  
)

export default component.exports